import { LocationOnRounded } from '@mui/icons-material'
import { formatMessageHtml } from '../../utils'
import { googleMapsUrl, imageBoxSize, messageKind, safeMediaUrl } from '../../utils/chatMedia'
import QuotedMessage from './QuotedMessage'

const nonEmptyText = value => (typeof value === 'string' && value.trim().length > 0 ? value : null)

const TimeLabel = ({ time, owner }) => (
  <p className={`text-xs font-thin shrink-0 ${owner ? 'text-white' : 'text-gray dark:text-gray-400'}`}>{time}</p>
)

const FormattedText = ({ text }) => (
  <p className='text-sm whitespace-pre-wrap' dangerouslySetInnerHTML={{ __html: formatMessageHtml(text) }} />
)

const Footer = ({ children, time, owner }) => (
  <div className='flex flex-row items-end justify-between gap-4'>
    {children || <span />}
    <TimeLabel time={time} owner={owner} />
  </div>
)

const ImageContent = ({ message, owner, time }) => {
  const url = safeMediaUrl(message.media.url)
  const box = imageBoxSize(message.media)
  const caption = nonEmptyText(message.caption)

  return (
    <div className='flex flex-col gap-1'>
      <a href={url} target='_blank' rel='noopener noreferrer' className='block w-fit'>
        <img
          src={url}
          alt={caption || 'Foto enviada en el chat'}
          loading='lazy'
          draggable={false}
          style={box || undefined}
          className='block rounded-lg object-cover max-w-[240px] max-h-[240px] bg-black/10'
        />
      </a>
      <Footer time={time} owner={owner}>
        {caption && <p className='text-sm whitespace-pre-wrap break-words'>{caption}</p>}
      </Footer>
    </div>
  )
}

const LocationContent = ({ message, owner, time }) => {
  const { location } = message
  const mapsUrl = googleMapsUrl(location)
  const thumbnail = safeMediaUrl(location.thumbnail_url)
  const name = nonEmptyText(location.name)
  const address = nonEmptyText(location.address)

  return (
    <div className='flex flex-col gap-1 max-w-[240px]'>
      {thumbnail ? (
        <a href={mapsUrl} target='_blank' rel='noopener noreferrer' className='block'>
          <img
            src={thumbnail}
            alt='Mapa de la ubicación'
            loading='lazy'
            draggable={false}
            className='block w-[240px] max-w-full aspect-[16/10] rounded-lg object-cover bg-black/10'
          />
        </a>
      ) : (
        <div
          className={`flex items-center justify-center w-[240px] max-w-full aspect-[16/10] rounded-lg ${
            owner ? 'bg-black/20' : 'bg-light_gray dark:bg-dk-raised'
          }`}
        >
          <LocationOnRounded sx={{ fontSize: 40, color: owner ? '#ffffff' : '#d65944' }} />
        </div>
      )}
      <p className='text-sm flex items-start gap-1'>
        <LocationOnRounded sx={{ fontSize: 16, marginTop: '2px' }} />
        <span className='break-words min-w-0'>{name || address || 'Ubicación'}</span>
      </p>
      {name && address && <p className='text-xs break-words'>{address}</p>}
      <Footer time={time} owner={owner}>
        <a
          href={mapsUrl}
          target='_blank'
          rel='noopener noreferrer'
          className={`text-sm underline ${owner ? 'text-white' : 'text-primary'}`}
        >
          Ver en Google Maps
        </a>
      </Footer>
    </div>
  )
}

export default function MessageBody({ message, owner, time, users }) {
  const kind = messageKind(message)
  const replyTo = message.reply_to && typeof message.reply_to === 'object' ? message.reply_to : null

  return (
    <>
      {replyTo && <QuotedMessage replyTo={replyTo} users={users} owner={owner} />}
      {kind === 'image' ? (
        <ImageContent message={message} owner={owner} time={time} />
      ) : kind === 'location' ? (
        <LocationContent message={message} owner={owner} time={time} />
      ) : (
        <div className='flex flex-row items-end gap-4'>
          <FormattedText text={message.text} />
          <TimeLabel time={time} owner={owner} />
        </div>
      )}
    </>
  )
}
